import Box from "@mui/material/Box";
import { TextInput } from "./Input";
import InputMask from "react-input-mask";
import { SelectInput } from "./SelectInput";
import { ChangeEvent, useEffect, useState } from "react";
import { AppContext } from "../context";
import { useContext } from "react";
import { format, parse } from "date-fns";
import { useHistory } from "react-router-dom";
import AlertField from "./Alert";
import {
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import { validateCpf, validateCellphone } from "../services/utils";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

import axios from "axios";
import { IDependents } from "../context";

export const DependentsForm = () => {
  const { setLoading, plan, sendDependents, lead, getLead } =
    useContext<any>(AppContext);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [cpfDependent, setCpfDependent] = useState("");
  const [nameDependent, setNameDependent] = useState("");
  const [birthdayDependent, setBirthdayDependent] = useState("");
  const [sexDependent, setSexDependent] = useState("");
  const [cellphoneDependent, setCellphoneDependent] = useState("");
  const [activeAddDependent, setActiveAddDependent] = useState(false);
  const [dependents, setDependents] = useState<Array<IDependents>>([]);

  useEffect(() => {
    console.log(lead.leadId);
    if (lead.dependents && lead.dependents.length > 0) {
      setDependents(lead.dependents);
    }
  }, []);

  const clearDependentsStates = () => {
    setCpfDependent("");
    setNameDependent("");
    setBirthdayDependent("");
    setSexDependent("");
    setCellphoneDependent("");
  };

  const handleClose = () => {
    setOpenAlert(false);
  };

  const maskCpf = (cpf: string) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  };

  const maskBirthday = (birthday: string) => {
    const arrayBirthday = birthday.split("-");
    const maskedBirthday = `${arrayBirthday[2]}/${arrayBirthday[1]}/${arrayBirthday[0]}`;
    return maskedBirthday;
  };

  const handleCpf = async (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    setCpfDependent(value);

    if (value.length === 11) {
      setLoading(true);

      try {
        const res = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API_BRIA}/${value}`,
          headers: {
            Authorization: `${process.env.REACT_APP_API_KEY}`,
          },
        });
        console.log(res.data);
        if (res.data) {
          setNameDependent(res.data.name);
          setBirthdayDependent(res.data.birthday);
          setSexDependent(res.data.sex);
          setCpfDependent(res.data.cpf);
        }

        setLoading(false);
      } catch (e: any) {
        setLoading(false);
      }
    }
  };

  const handleBirthday = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setBirthdayDependent(e.target.value);
  };

  const handleCellphone = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setCellphoneDependent(e.target.value);
  };

  const genderOptions = [
    { value: "", label: "" },
    { value: "M", label: "Masculino" },
    { value: "F", label: "Feminino" },
    { value: "O", label: "Outro" },
  ];
  const handleGender = (value: string) => {
    setSexDependent(value);
  };

  const addDependent = () => {
    console.log(plan.numberDependents);
    setLoading(true);
    const data = {
      cpf: cpfDependent,
      birthday: birthdayDependent,
      sex: sexDependent,
      name: nameDependent,
      cellphone: cellphoneDependent,
    };

    if (!data.cpf) {
      setAlertMessage("CPF não informado!");
      setOpenAlert(true);
    } else if (!data.birthday) {
      setAlertMessage("Data de nascimento não informada!");
      setOpenAlert(true);
    } else if (!data.sex) {
      setAlertMessage("Sexo não selecionado!");
      setOpenAlert(true);
    } else if (!data.name) {
      setAlertMessage("Nome não informado!");
      setOpenAlert(true);
    } else if (!data.cellphone) {
      setAlertMessage("Celular não informado!");
      setOpenAlert(true);
    } else if (!validateCellphone(data.cellphone)) {
      setAlertMessage("Telefone inválido!");
      setOpenAlert(true);
    } else if (!validateCpf(data.cpf)) {
      setAlertMessage("CPF Inválido!");
      setOpenAlert(true);
    } else {
      const formatedDate = format(
        parse(data.birthday, "dd/MM/yyyy", new Date()),
        "yyyy-MM-dd"
      );
      console.log("formated date", formatedDate);
      data.birthday = formatedDate;
      const new_dependents: IDependents[] = [...dependents, data];
      if (new_dependents.length === (plan.numberDependents as number)) {
        setActiveAddDependent(true);
      }
      setDependents(new_dependents);
      clearDependentsStates();
    }
    setLoading(false);
  };
  const history = useHistory();

  const submitDependents = async () => {
    if (dependents.length > 0) {
      const sendedDependents = await sendDependents(dependents);
      if (sendedDependents) {
        history.push("/revisao");
      }
    }
  };
  return (
    <>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "background.default",
        }}
      >
        <Paper
          variant="outlined"
          elevation={2}
          sx={{
            backgroundColor: "background.default",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <AlertField
              message={alertMessage}
              status={openAlert}
              handle={handleClose}
            />
          </Box>
          <Grid
            container
            sx={{ px: 4, py: 3, maxWidth: 900 }}
            rowSpacing={1}
            spacing={1}
          >
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <InputMask
                  defaultValue={cpfDependent}
                  mask="999.999.999-99"
                  onChange={handleCpf}
                  value={cpfDependent}
                >
                  {
                    //@ts-ignore
                    () => (
                      <TextField
                        sx={{ width: "100%" }}
                        id="cpf"
                        label="CPF"
                        variant="outlined"
                        color="secondary"
                        size="small"
                      />
                    )
                  }
                </InputMask>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <InputMask
                  defaultValue={birthdayDependent}
                  mask="99/99/9999"
                  onChange={handleBirthday}
                  value={birthdayDependent}
                >
                  {
                    //@ts-ignore
                    () => (
                      <TextField
                        sx={{ width: "100%" }}
                        id="bithday"
                        label="Nascimento"
                        variant="outlined"
                        color="secondary"
                        size="small"
                      />
                    )
                  }
                </InputMask>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <SelectInput
                  label="Sexo"
                  id="sex"
                  options={genderOptions}
                  handleClick={handleGender}
                  value={sexDependent}
                  defaultValue={sexDependent}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput id="name" label="Nome" value={nameDependent} />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <InputMask
                  defaultValue={cellphoneDependent}
                  mask="(99) 99999-9999"
                  onChange={handleCellphone}
                  value={cellphoneDependent}
                >
                  {
                    //@ts-ignore
                    () => (
                      <TextField
                        sx={{ width: "100%" }}
                        id="cellphone"
                        label="Celular"
                        variant="outlined"
                        color="secondary"
                        size="small"
                      />
                    )
                  }
                </InputMask>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <Tooltip title="Adicionar dependente">
              <Button
                sx={{ margin: "auto", mb: 2, width: 150 }}
                variant="contained"
                color="primary"
                onClick={addDependent}
                disabled={activeAddDependent}
              >
                <PersonAddIcon />
              </Button>
            </Tooltip>
            <Button
              sx={{ margin: "auto", mb: 2, width: 150 }}
              variant="contained"
              color="primary"
              onClick={submitDependents}
              disabled={dependents.length === 0}
            >
              Prosseguir
            </Button>
          </Box>
        </Paper>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "background.default",
        }}
      >
        {dependents.length > 0 && (
          <Grid
            container
            sx={{ px: 4, py: 3, mt: 1, maxWidth: 1200 }}
            rowSpacing={1}
            spacing={1}
          >
            <Typography sx={{ color: "primary.main", fontSize: "1.2rem" }}>
              Dependentes
            </Typography>
          </Grid>
        )}
        {dependents.length > 0 &&
          dependents.map((dependent: IDependents, i: number) => (
            <Grid
              container
              sx={{ px: 4, py: 1, maxWidth: 900 }}
              rowSpacing={0}
              spacing={0}
              key={`${i}-dependent`}
            >
              <Grid item xs={12} sm={4}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  <TextField
                    id={"cpf" + i.toString()}
                    key={"cpf" + i.toString()}
                    value={maskCpf(dependent.cpf)}
                    variant="standard"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  <TextField
                    id={"name" + i.toString()}
                    key={"name" + i.toString()}
                    value={dependent.name}
                    variant="standard"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  <TextField
                    id={"birthday" + i.toString()}
                    key={"birthday" + i.toString()}
                    value={maskBirthday(dependent.birthday)}
                    variant="standard"
                  />
                </Box>
              </Grid>
            </Grid>
          ))}
      </Box>
    </>
  );
};
